export const ONE_SECOND = 1_000;
export const FIVE_SECONDS = ONE_SECOND * 5;
export const FIFTEEN_SECONDS = ONE_SECOND * 15;
export const THIRTY_SECONDS = ONE_SECOND * 30;
export const ONE_MINUTE = ONE_SECOND * 60;
export const TEN_MINUTES = ONE_MINUTE * 10;
export const THIRTY_MINUTES = ONE_MINUTE * 30;
export const ONE_HOUR = ONE_MINUTE * 60;
export const SIX_HOURS = ONE_HOUR * 6;
export const ONE_DAY = ONE_HOUR * 24;

export function getMsToEndOfDay(): number {
  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999);
  const now = new Date();
  return endOfDay.valueOf() - now.valueOf();
}
